// @spec DHB-STR-010
// Wizard route page for guided data entry

import { createFileRoute } from '@tanstack/react-router';

import { DataEntryWizard } from '@/features/datahub/wizard';

export const Route = createFileRoute('/_authenticated/datahub/entry/wizard')({
  component: DataEntryWizardPage,
});

function DataEntryWizardPage() {
  return (
    <div className="p-8">
      <div className="mx-auto max-w-5xl">
        <DataEntryWizard />
      </div>
    </div>
  );
}
